import React from 'react';
import { Star } from 'lucide-react';

const renderStatusBadge = (status) => {
    const s = String(status || '').toUpperCase();
    if (s === 'SELECTED') return <span className="badge bg-success fw-bold px-2 py-1">SELECTED</span>;
    if (s === 'REJECTED') return <span className="badge bg-danger fw-bold px-2 py-1">REJECTED</span>;
    if (s === 'RESUBMIT') return <span className="badge bg-warning text-dark fw-bold px-2 py-1">RESUBMIT</span>;
    return <span className="badge bg-secondary fw-bold px-2 py-1">{status || 'PENDING'}</span>;
};

const ReviewLogsTable = ({ selectedApp }) => {
    if (!selectedApp?.staffComment && !selectedApp?.review && !selectedApp?.modified_by_admin) {
        return null;
    }

    return (
        <div className="card-dark p-3 rounded-3" style={{ background: '#121212', border: '1px solid rgba(255, 255, 255, 0.08)' }}>
            <div className="fw-bold mb-3 text-danger d-flex align-items-center gap-2" style={{ fontSize: '0.9rem' }}>
                📝 Audition Review Logs
            </div>
            <div className="table-responsive">
                <table className="table table-dark table-bordered align-middle mb-0" style={{ fontSize: '0.825rem', borderColor: 'rgba(255, 255, 255, 0.08)' }}>
                    <thead className="table-dark">
                        <tr style={{ background: '#1a1a1a', color: '#888888' }}>
                            <th>Reviewer Role</th>
                            <th>Comment / Review</th>
                            <th>Rating</th>
                            <th>Decision Status</th>
                        </tr>
                    </thead>
                    <tbody>
                        {selectedApp?.staffComment && (
                            <tr>
                                <td className="text-warning fw-bold">Staff</td>
                                <td className="text-light" style={{ minWidth: '150px' }}>{selectedApp.staffComment}</td>
                                <td>
                                    <div className="d-flex gap-1 text-warning">
                                        {Array.from({ length: 5 }, (_, idx) => (
                                            <Star key={idx} size={13} fill={idx < (parseInt(selectedApp.ratingStar, 10) || 0) ? "currentColor" : "none"} />
                                        ))}
                                    </div>
                                </td>
                                <td>{renderStatusBadge(selectedApp.result)}</td>
                            </tr>
                        )}
                        {selectedApp?.review && (
                            <tr>
                                <td className="text-success fw-bold">Casting Director</td>
                                <td className="text-light" style={{ minWidth: '150px' }}>{selectedApp.review}</td>
                                <td>
                                    <div className="d-flex gap-1 text-warning">
                                        {Array.from({ length: 5 }, (_, idx) => (
                                            <Star key={idx} size={13} fill={idx < (parseInt(selectedApp.ratingStar || selectedApp.c_ratingStar, 10) || 0) ? "currentColor" : "none"} />
                                        ))}
                                    </div>
                                </td>
                                <td>{renderStatusBadge(selectedApp.result)}</td>
                            </tr>
                        )}
                        {selectedApp?.modified_by_admin && (
                            <tr>
                                <td className="text-info fw-bold">Admin (Modified)</td>
                                <td className="text-light" style={{ minWidth: '150px' }}>{selectedApp.modified_by_admin}</td>
                                <td>
                                    <div className="d-flex gap-1 text-warning">
                                        {Array.from({ length: 5 }, (_, idx) => (
                                            <Star key={idx} size={13} fill={idx < (parseInt(selectedApp.ratingStar || selectedApp.c_ratingStar, 10) || 0) ? "currentColor" : "none"} />
                                        ))}
                                    </div>
                                </td>
                                <td>{renderStatusBadge(selectedApp.result)}</td>
                            </tr>
                        )}
                    </tbody>
                </table>
            </div>
        </div>
    );
};

export default ReviewLogsTable;
